/**
 * Messages synced into Wix Inbox from an outside service (our email carrier today).
 *
 * Wix's documented way to show an outside service's messages in Inbox (the "Sync messages from an external
 * service" flow) is to send them with `visibility: "BUSINESS"` so the customer's site chat never displays them,
 * and a badge naming where they came from. But our Inbox treats every `visibility: "BUSINESS"` message as an
 * automated business notice (email campaign opened, new order, invoice…) — it never updates the conversation row,
 * unread count or staff alert, and conversations made only of them are dropped from the list.
 *
 * A synced message is told apart from a business notice by its badge, so those filters let it through.
 */
export const SYNCED_MESSAGE_BADGE_EMAIL = 'Email';

const SYNCED_BADGE_PREFIXES = [SYNCED_MESSAGE_BADGE_EMAIL.toLowerCase()];

/** True when a Wix message carries the badge of an outside service synced into Inbox (not a business notice). */
export const isSyncedExternalMessage = (message: unknown): boolean => {
  const badges = (message as { badges?: Array<{ text?: unknown }> } | null | undefined)?.badges;
  // The badge reads "Email" or "Email · <mailbox>"
  return Array.isArray(badges) && badges.some((b) => {
    const text = String(b?.text ?? '').trim().toLowerCase();
    return SYNCED_BADGE_PREFIXES.some((prefix) => text === prefix || text.startsWith(`${prefix} `));
  });
};
